import { Webhook } from 'lucide-react';

export function WebhooksCard() {
  return (
    <div className="w-full border border-surface-soft-border rounded-[20px] p-4 lg:p-5 text-black-logo space-y-4">
      <h5 className="text-base lg:text-lg lg:leading-[22px] font-semibold">Webhooks</h5>
      <div className="w-full h-px bg-grayEF" />

      <div className="flex flex-col items-center justify-center gap-3 py-10 text-center">
        <div className="w-12 h-12 rounded-full bg-blue-tint flex items-center justify-center">
          <Webhook className="w-6 h-6 text-primary" />
        </div>
        <div className="space-y-1">
          <p className="text-sm font-medium text-black-logo">Managed in SignCare Console</p>
          <p className="text-sm text-gray66 max-w-sm">
            Webhook endpoints are configured in the Console portal. Visit the Console to set up
            event notifications for your workspace.
          </p>
        </div>
      </div>
    </div>
  );
}
